import React, { useMemo, useState } from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useVendasSuprimentos } from "./vendasData";
import { generatePdfReport } from "../../../utils/pdf/generatePdfReport";

const SuprimentosVendas: React.FC = () => {
  const headers = [
    "PV",
    "Tipo",
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Cliente",
    "Responsável",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useVendasSuprimentos();

  const columnWidths = [
    "60px", // PV
    "80px", // Tipo
    "70px", // Código
    "300px", // Nome do Produto
    "60px", // Quantidade
    "100px", // Custo Unitário
    "160px", // Cliente
    "160px", // Responsável
    "90px", // Data
    "60px", // Hora
  ];

  const [selectedColumns, setSelectedColumns] = useState<boolean[]>(
    headers.map(() => true)
  );

  const enabledColumnIndexes = useMemo(
    () =>
      selectedColumns
        .map((checked, i) => (checked ? i : -1))
        .filter((i) => i !== -1),
    [selectedColumns]
  );

  const footerLines = useMemo(() => {
    let totalQuantidade = 0;

    rows.forEach((row) => {
      const qtd = Number(String(row[4] ?? "").replace(",", "."));
      if (isFinite(qtd)) totalQuantidade += qtd;
    });

    return [`Total de Itens Vendidos: ${totalQuantidade}`];
  }, [rows]);

  return (
    <div>
      <TitleButtons
        title="Suprimentos - Vendas"
        buttons={[
          {
            label: "Gerar Relatório",
            onClick: () =>
              generatePdfReport({
                reportTitle: "Relatório de Vendas",
                fileNamePrefix: "Comercial-Vendas-finalizadas",
                subtitle:
                  "Informações Saídas Finalizadas de Material para Venda",
                headers,
                rows,
                custoColIndex: 5,
                enabledColumns: enabledColumnIndexes,
                footerLines,
              }),
            variant: "secondary",
            dropdownOptions: headers.map((h, i) => ({
              label: h,
              checked: selectedColumns[i],
            })),
            onOptionChange: (index, checked) => {
              const updated = [...selectedColumns];
              updated[index] = checked;
              setSelectedColumns(updated);
            },
          },
        ]}
      />

      {loading ? (
        <div style={{ padding: 16 }}>Carregando vendas…</div>
      ) : (
        <Table
          headers={headers}
          rows={rows}
          columnWidths={columnWidths}
          isTableStandby
        />
      )}
    </div>
  );
};

export default SuprimentosVendas;
